<template>
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div class="col-xl-5 b-center bg-size"
        :style="{ backgroundImage: 'url('+ require('@/assets/images/login/3.jpg') +')' }"
        style="background-size: cover; background-position: center center; display: block;">
        <img class="bg-img-cover bg-center" src="@/assets/images/login/3.jpg" alt="looginpage" style="display: none;" />
      </div>
      <div class="col-xl-7 p-0">
        <div class="login-card">
          <div>
            <div><a class="logo text-center"><router-link to="/"><img class="img-fluid"
                    src="@/assets/images/logo/logo.png" alt="logo image"></router-link></a></div>
            <div class="login-main">
              <form class="theme-form">
                <h2>Create your account</h2>
                <p>Enter your personal details to create account</p>
                <div class="form-group">
                  <label class="col-form-label pt-0">Your Name</label>
                  <div class="row g-2">
                    <div class="col-6">
                      <input class="form-control" type="text" required="" placeholder="First name">
                    </div>
                    <div class="col-6">
                      <input class="form-control" type="text" required="" placeholder="Last name">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Email Address</label>
                  <input class="form-control" type="email" required="" placeholder="Test@gmail.com">
                </div>
                <div class="form-group">
                  <label class="col-form-label">Password</label>
                  <div class="form-input position-relative">
                    <input class="form-control" type="password" name="login[password]" required=""
                      placeholder="*********">
                    <div class="show-hide"><span class="show"></span></div>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <div class="checkbox p-0">
                    <input id="checkbox1" type="checkbox">
                    <label class="text-muted" for="checkbox1">Agree with<a class="ms-2" href="javascript:void(0)">Privacy
                        Policy</a></label>
                  </div>
                  <router-link to="/"><button class="btn btn-primary btn-block w-100 mt-3" type="submit">Create
                      Account</button></router-link>
                </div>
                <div class="login-social-title">
                  <h3>Or Sign in with </h3>
                </div>
                <div class="form-group">
                  <ul class="login-social">
                    <li><a href="https://www.facebook.com" target="_blank"><i class="fa fa-facebook"></i></a></li>
                    <li><a href="https://www.linkedin.com" target="_blank"><i class="fa fa-linkedin"> </i></a></li>
                    <li><a href="https://www.twitter.com" target="_blank"><i class="fa fa-twitter"></i></a></li>
                    <li><a href="https://www.instagram.com" target="_blank"><i class="fa fa-instagram"></i></a></li>
                  </ul>
                </div>
                <p class="mt-4 mb-0 text-center">Already have an account?<router-link class="ms-2"
                    to="/authenticaton/login">Sign in</router-link></p>
              </form>
            </div>
          </div>
        </div>
    </div>
  </div>


</div></template>